module.exports = __webpack_public_path__ + "static/media/lmbc3.8c193acf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/lmbc3.jpg
// module id = 117
// module chunks = 0